import { put } from "redux-saga/effects";
import { serversURL } from "../../api";

import { fetchServerStatisticsSuccess } from "./actions";

export function* fetchAsync(date) {
  try {
    const response = yield fetch(`${serversURL}/${date}`, {
      method: "GET",
    });
    const json = yield response.json();
    yield put(fetchServerStatisticsSuccess(json));
  } catch (error) {
    console.log(error.message);
  }
}
